import { http } from '@/http';
import { CmsError } from '@/http/CmsError';
import './FavoritesWidget.scss';
import {
    IFavoritesWidget,
    CountOutputElement,
    WidgetElement,
    ItemId,
    ClickedElement,
} from './types';

/**
 *
 */
export class FavoritesWidget implements IFavoritesWidget {
    /**
     *
     */
    static TOGGLE_URL: string =
        process.env.NODE_ENV === 'development'
            ? '/mock/toggle-favorites'
            : '/rest-api/toggle-favorites.json';
    /**
     *
     */
    public count: number;
    /**
     *
     */
    protected readonly countOutputElement: CountOutputElement;
    /**
     *
     * @param el
     */
    constructor(protected readonly widgetElement: WidgetElement) {
        this.countOutputElement = widgetElement?.querySelector('.favorites-link__count')!;
        this.count = Number(widgetElement?.getAttribute('data-count')) || 0;
    }
    /**
     *
     */
    protected updateView() {
        this.widgetElement?.setAttribute('data-count', String(this.count));
        this.countOutputElement.innerHTML = String(this.count);
    }
    /**
     *
     * @param id
     * @returns
     */
    protected makeRequest(id: ItemId) {
        return http.get<{ favorites: ItemId[] }>(FavoritesWidget.TOGGLE_URL, {
            params: { id },
        });
    }
    /**
     *
     * @param event
     * @param el
     * @param itemId
     * @param deleteCard
     */
    public async toggle(
        event: Event,
        el: ClickedElement,
        itemId: ItemId,
        deleteCard?: boolean
    ) {
        event.preventDefault();

        if (!deleteCard) {
            if (el.classList.contains('active')) {
                el.classList.remove('active');
                el.setAttribute('title', 'Добавить в избранное');
            } else {
                el.classList.add('active');
                el.setAttribute('title', 'Удалить из избранного');
            }
        } else {
            const toDelete = el.closest('.product-card-v1')?.parentElement;
            toDelete?.parentElement?.removeChild(toDelete);
        }

        try {
            const { data } = await this.makeRequest(itemId);
            this.count = data.favorites.length;
            this.updateView();
            window.dispatchEvent(new Event('favoritesChange'));
        } catch (error) {
            console.error(error);
            error instanceof CmsError && console.log(error.details);
        }
    }
}
